import React, {useMemo} from 'react';
import PropTypes from "prop-types";
import * as Icon from 'ubs-icons';
import { COLOR } from '../../constant';
import UPopup from "ubs-framework/v2/UPopup";
import { isMobileDevice } from '../../function';

const ActionItem = React.memo((props) => {
    const getIcon = useMemo(() => {
        if (['assign'].includes(props?.type)) {
            return <Icon.MultiUser fill={COLOR?.u_blue} size={18}/>;
        }
        if (['copy', 'clone'].includes(props?.type)) {
            return <Icon.Copy fill={COLOR?.u_blue} size={16}/>;
        }
        if (['revoke'].includes(props?.type)) {
            return <Icon.In fill={COLOR?.u_blue} size={16}/>;
        }
        if (['delete'].includes(props?.type)) {
            return <Icon.Delete fill={COLOR?.u_blue} size={16}/>;
        }
        if (['edit'].includes(props?.type)) {
            return <Icon.Edit fill={COLOR?.u_blue} size={16}/>;
        }
        if (['cancel', 'close'].includes(props?.type)) {
            return <Icon.Close fill={COLOR?.u_blue} size={16}/>;
        }
        if (['activity', 'history'].includes(props?.type)) {
            return <Icon.History fill={COLOR?.u_blue} size={16}/>;
        }
        if (['approve'].includes(props?.type)) {
            return <Icon.CheckMark fill={COLOR?.u_blue} size={16}/>;
        }
        if (['view'].includes(props?.type)) {
            return <Icon.Eye fill={COLOR?.u_blue} size={16}/>;
        }
        if (['preview'].includes(props?.type)) {
            return <Icon.FilePreview fill={COLOR?.u_blue} size={16}/>;
        }
        if (['hide-view'].includes(props?.type)) {
            return <Icon.HideEye fill={COLOR?.u_blue} size={16}/>;
        }
        if (['download'].includes(props?.type)) {
            return <Icon.Download fill={COLOR.u_blue} size={16}/>;
        }
        if (['lock'].includes(props?.type)) {
            return <Icon.Lock fill={COLOR.u_blue} size={16}/>;
        }
        if (['unlock'].includes(props?.type)) {
            return <Icon.UnLock fill={COLOR.u_blue} size={16}/>;
        }
        if (['info'].includes(props?.type)) {
            return <Icon.Info fill={COLOR?.u_blue} size={16}/>;
        }
        if (['leave'].includes(props?.type)) {
            return <Icon.Out fill={COLOR?.u_blue} size={16}/>;
        }
        if (['comment', 'chat'].includes(props?.type)) {
            return <Icon.CommentFill fill={COLOR?.u_blue} size={16}/>;
        }
        if (['upload'].includes(props?.type)) {
            return <Icon.Upload fill={COLOR?.u_blue} size={16}/>;
        }
        if (['travel'].includes(props?.type)) {
            return <Icon.Travel fill={COLOR?.u_blue} size={16}/>;
        }
        if (['score'].includes(props?.type)) {
            return <Icon.Score fill={COLOR?.u_blue} size={16}/>;
        }
        if (['camera'].includes(props?.type)) {
            return <Icon.Camera fill={COLOR?.u_blue} size={16}/>;
        }
        if (['reload'].includes(props?.type)) {
            return <Icon.Reload fill={COLOR?.u_blue} size={16}/>;
        }
        if (['restore'].includes(props?.type)) {
            return <Icon.Restore fill={COLOR?.u_blue} size={16}/>;
        }
        if (['suspend', 'pause'].includes(props?.type)) {
            return <Icon.Pause fill={COLOR?.u_blue} size={16}/>;
        }
        if (['preLoader'].includes(props?.type)) {
            return <Icon.Preloader fill={COLOR?.u_blue} size={18}/>;
        }
        if (['loan'].includes(props?.type)) {
            return <Icon.Loan fill={COLOR?.u_blue} size={18}/>;
        }
        if (['live'].includes(props?.type)) {
            return <Icon.Live fill={COLOR?.u_blue} size={22}/>;
        }
        if (['add-file'].includes(props?.type)) {
            return <Icon.AddFile fill={COLOR?.u_blue} size={16} />;
        }
        if (['status'].includes(props?.type)) {
            return <Icon.Activities fill={COLOR?.u_blue} size={16} />;
        }
         if (['policy-automation'].includes(props?.type)) {
            return <Icon.GroupByFilter fill={COLOR?.u_blue} size={16}/>;
        }
        if (['email'].includes(props?.type)) {
            return <Icon.Mail fill={COLOR.u_blue} size={16}/>
        }
        if (['watch'].includes(props?.type)) {
            return <Icon.Watch fill={COLOR.u_blue} size={16}/>
        }
        if (['calendar'].includes(props?.type)) {
            return <Icon.Calendar fill={COLOR.u_blue} size={16}/>
        }
        if (['redirect'].includes(props?.type)) {
            return <Icon.Redirect fill={COLOR.u_blue} size={16}/>
        }
        if (['remove-bio'].includes(props?.type)) {
            return <Icon.UserCancel fill={COLOR.u_blue} size={16}/>
        }
        if (['remove-penalty'].includes(props?.type)) {
            return  <Icon.RemovePenaltyIcon fill={COLOR.u_blue} size={16}/>
        }
        if (['reprocess-penalty'].includes(props?.type)) {
            return <Icon.Revise fill={COLOR.u_blue} size={16}/>
        }
        if (['active'].includes(props?.type)) {
            return <Icon.Checked fill={COLOR.u_blue} size={16}/>
        }
        if (['link'].includes(props?.type)) {
            return <Icon.Link fill={COLOR.u_blue} size={16}/>
        }
        if (['verify'].includes(props?.type)) {
            return <Icon.Active fill={COLOR.u_blue} size={18}/>
        }
        if (['user-block'].includes(props?.type)) {
            return <Icon.UserBlock fill={COLOR.u_blue} size={18}/>
        }
        if (['finalSettle'].includes(props?.type)) {
            return <Icon.FinalSettle fill={COLOR.u_blue} size={18}/>
        }
        if (['addEmployee'].includes(props?.type)) {
            return <Icon.UserAdd fill={COLOR.u_blue} size={18}/>
        }
    }, [props?.type])
    return (
        <UPopup
            params={{className: "u_tooltip", disabled: isMobileDevice()}}
            desc={<span>{props?.text ? props?.text : props?.type}</span>}
        >
            <span className={`u_icon-rollover u_cp u_ml-5 ${props?.className ? props?.className : ''}`} onClick={e => {
                e.preventDefault()
                props?.onClick(e)
            }}>{getIcon}</span>
        </UPopup>
    );
});

ActionItem.propTypes = {
    text: PropTypes.string,
    type: PropTypes.string,
    onClick: PropTypes.func,
}

ActionItem.defaultProps = {
    text: '',
    type: '',
    onClick: () => {

    },
};

export default ActionItem;
